
import { Badge } from "@/components/ui/badge";
import { Part, PartCategory } from "@/data/parts";

interface PartCardHeaderProps {
  part: Part;
  handleCategoryClick: (e: React.MouseEvent, category: PartCategory) => void;
  goToPartDetails: () => void;
}

const PartCardHeader = ({ part, handleCategoryClick, goToPartDetails }: PartCardHeaderProps) => {
  return (
    <div className="mb-3">
      {/* Manufacturer and category badge on the first line */}
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm text-muted-foreground text-left">
          {part.manufacturer || 'Creality'}
        </span>
        <Badge 
          variant={part.category === "k1_series" ? "default" : "secondary"}
          onClick={(e) => handleCategoryClick(e, part.category)}
          className="cursor-pointer hover:opacity-80 transition-opacity text-xs px-2 py-0"
        >
          {part.category === "k1_series" ? "K1" : part.category === "k2_series" ? "K2" : "TOOLS"}
        </Badge>
      </div>
      
      {/* Title with single line clamp */}
      <div>
        <h3 
          className="font-bold text-lg cursor-pointer hover:text-primary hover:underline line-clamp-1 text-left"
          onClick={goToPartDetails}
          title={part.name} // Show full title on hover
        >
          {part.name}
        </h3>
      </div>
    </div>
  );
};

export default PartCardHeader;
